import React, {useState} from 'react';

type SubHeaderDisclosureProps = {
    buttonId: string;
    panelId: string;
    title: React.ReactNode;
    defaultOpen: boolean;
    panelClassName?: string;
    panelStyle?: React.CSSProperties;
    children: React.ReactNode;
};

/**
 * Product sub-header that used to be a Bootstrap collapse trigger.
 * React owns aria-expanded and the show class so a later render cannot write the closed state back over an open panel.
 * `collapsed` is added only after a toggle: Bootstrap added it then, and the first paint of a closed section did not have it.
 */
export const SubHeaderDisclosure: React.FC<SubHeaderDisclosureProps> = ({buttonId, panelId, title, defaultOpen, panelClassName, panelStyle, children}) => {
    const [open, setOpen] = useState(defaultOpen);
    const [hasToggled, setHasToggled] = useState(false);
    const extra = panelClassName ? ` ${panelClassName}` : '';

    return (
        <>
            <button
                type="button"
                id={buttonId}
                className={`prod-sub-header toggle-bs${hasToggled && !open ? ' collapsed' : ''}`}
                aria-expanded={open}
                aria-controls={panelId}
                onClick={() => {
                    setHasToggled(true);
                    setOpen(value => !value);
                }}
            >
                {title}
            </button>
            <div
                id={panelId}
                className={`collapse${open ? ' show' : ''}${extra}`}
                style={panelStyle}
            >
                {children}
            </div>
        </>
    );
};
